import React from 'react';
import MaterialUITextInput from '../../TextFieldInput/MaterialUITextInput';

interface StationFilterProps {
    stationValue: string;
    onStationValueChange: (station: string) => void;
    onStationError: (error: boolean) => void;
    error: boolean; 
}

const STATION_PATTERN = /^[A-Za-z]{3}$/;

const StationFilter: React.FC<StationFilterProps> = ({
    stationValue,
    onStationValueChange,
    onStationError,
    error 
}) => {
   const handleStationValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toUpperCase();
    onStationValueChange(value);
    const isValid = value === '' || STATION_PATTERN.test(value);
    onStationError(!isValid); 
  };

    return (
        <div className="form-input">
            <MaterialUITextInput
                label="Station"
                value={stationValue}
                onChange={handleStationValue}
                error={error}
                helperText={error ? "invalid entry" : ""}
                className="station-filter-input"
                inputProps={{
                    autoComplete: "off",
                    maxLength: 3,
                    minLength: 3,
                    pattern: "[A-Za-z]{3}",
                    inputMode: "text",
                    'data-testid': "station"
                }}
            />
        </div>
    );
};

export default StationFilter;
